import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const currentIssueListSlice = createSlice({
    name: 'currentIssueList',
    initialState: [],
    reducers: {
        update: (state, action) => action.payload ?? state,
        reset: (state, action) => [],
    },
});

export const { update, reset } = currentIssueListSlice.actions;

export default currentIssueListSlice.reducer;
